import { z } from 'zod'

export const ADMINFORMSASSIGNMENTSDELETE_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsAssignmentsDeleteResponseSchema = z.unknown()
export type AdminFormsAssignmentsDeleteResponse = z.infer<typeof adminFormsAssignmentsDeleteResponseSchema>
